
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.single-dropdown.child-link').forEach(function (drop) {
      const hero = drop.querySelector('.mega__hero img');
      if (!hero) return;

      const defaultSrc = hero.getAttribute('data-default-hero') || hero.getAttribute('src');

      function swapHero(src) {
        if (!src || src === hero.src) return;
        hero.classList.add('is-swapping');
        const img = new Image();
        img.onload = function () {
          hero.src = src;
          hero.classList.remove('is-swapping');
        };
        img.src = src;
      }

      function getColDefault(el) {
        const col = el.closest('.mega__col');
        return col ? col.getAttribute('data-hero') : null;
      }

      // 1) When hovering a link, show that link's image
      drop.querySelectorAll('.mega__hoverable').forEach(function (a) {
        a.addEventListener('mouseenter', function () {
          const src = a.getAttribute('data-hero') || getColDefault(a) || defaultSrc;
          swapHero(src);
        });
        a.addEventListener('focus', function () {
          const src = a.getAttribute('data-hero') || getColDefault(a) || defaultSrc;
          swapHero(src);
        });

        // IMPORTANT: do NOT revert on link mouseleave if moving within same column
        a.addEventListener('mouseleave', function (e) {
          const col = a.closest('.mega__col');
          // if the new element is still inside this column, keep the last image
          if (col && e.relatedTarget && col.contains(e.relatedTarget)) return;
          // leaving the column entirely is handled by the column mouseleave below
        });
        a.addEventListener('blur', function (e) {
          const col = a.closest('.mega__col');
          if (col && e.relatedTarget && col.contains(e.relatedTarget)) return;
        });
      });

      // 2) Only when the pointer/focus leaves the whole column, revert to the column default
      drop.querySelectorAll('.mega__col').forEach(function (col) {
        const colDefault = col.getAttribute('data-hero') || defaultSrc;

        col.addEventListener('mouseleave', function () {
          swapHero(colDefault);
        });

        col.addEventListener('focusout', function (e) {
          if (!col.contains(e.relatedTarget)) swapHero(colDefault);
        });
      });

      // 3) When leaving the entire dropdown, revert to top-level default
      drop.addEventListener('mouseleave', function () {
        swapHero(defaultSrc);
      });
      drop.addEventListener('focusout', function (e) {
        if (!drop.contains(e.relatedTarget)) swapHero(defaultSrc);
      });
    });
  });
